<template>
  <div
    v-if="variant === 'row'"
    class="h-[72px] bg-white rounded-[8px] border border-gray-50 ps-3 pe-4 flex flex-row items-center gap-2"
  >
    <integration-icon :integration-id="integration.id" />
    <div class="flex-1 min-w-0">
      <div class="text-base leading-6 font-semibold text-gray-800">
        {{ integration.name }}
      </div>
      <div class="text-sm leading-5 text-gray-600 truncate mt-1">
        {{ integration.description }}
      </div>
    </div>
    <div class="flex flex-row items-center gap-[60px]">
      <tag-v2 v-if="category" :color="tagColor">
        {{ categoryLabel }}
      </tag-v2>
      <div class="w-9">
        <switch-v2
          v-if="showToggle"
          :value="enabled"
          :disabled="toggleDisabled"
          :aria-label="integration.name"
          @input="$emit('toggle', $event)"
        />
      </div>
      <button-v2
        variant="naked"
        size="sm"
        class="!px-2 ltr:!ps-3 ltr:!pe-1"
        icon="arrow_forward"
        icon-position="end"
        icon-class="rtl:rotate-180 !text-[20px]"
        :disabled="manageDisabled"
        @click="$emit('manage')"
      >
        {{ $t('INTEGRATION_SETTINGS.LIST.MANAGE') }}
      </button-v2>
    </div>
  </div>
  <div
    v-else
    class="h-[220px] bg-white rounded-[8px] border border-gray-50 flex flex-col"
  >
    <div class="p-4 pb-3 flex-1 min-h-0">
      <div class="flex flex-row items-start justify-between">
        <integration-icon :integration-id="integration.id" />
        <tag-v2 v-if="category" :color="tagColor">
          {{ categoryLabel }}
        </tag-v2>
      </div>
      <div class="text-base leading-6 font-semibold text-gray-800 mt-2">
        {{ integration.name }}
      </div>
      <div class="text-sm leading-5 text-gray-600 mt-1 line-clamp-3">
        {{ integration.description }}
      </div>
    </div>
    <div
      class="h-12 px-4 border-t border-gray-100 flex flex-row items-center justify-between"
    >
      <button-v2
        variant="ghost"
        size="sm"
        :disabled="manageDisabled"
        @click="$emit('manage')"
      >
        {{ $t('INTEGRATION_SETTINGS.LIST.MANAGE') }}
      </button-v2>
      <switch-v2
        v-if="showToggle"
        :value="enabled"
        :disabled="toggleDisabled"
        :aria-label="integration.name"
        @input="$emit('toggle', $event)"
      />
    </div>
  </div>
</template>

<script>
import IntegrationIcon from './IntegrationIcon.vue';

const CATEGORY_TAG_COLORS = {
  communication: 'primary-01',
  developer: 'primary-03',
  ai: 'primary-06',
  system: 'mute-01',
};

export default {
  name: 'IntegrationCard',
  components: { IntegrationIcon },
  props: {
    integration: { type: Object, required: true },
    variant: { type: String, default: 'grid' },
    category: { type: String, default: '' },
    enabled: { type: Boolean, default: false },
    showToggle: { type: Boolean, default: false },
    toggleDisabled: { type: Boolean, default: false },
    manageDisabled: { type: Boolean, default: false },
  },
  computed: {
    tagColor() {
      return CATEGORY_TAG_COLORS[this.category] || 'mute-01';
    },
    categoryLabel() {
      if (!this.category) return '';
      return this.$t(
        `INTEGRATION_SETTINGS.LIST.CATEGORIES.${this.category.toUpperCase()}`
      );
    },
  },
};
</script>
